import type { ChatSnapPreview } from "./use-detached-chat-window";

export function ChatWindowSnapPreview({
  preview,
}: {
  preview: ChatSnapPreview | null;
}) {
  if (!preview) return null;
  return (
    <div
      aria-hidden="true"
      data-testid={`chat-snap-preview-${preview.mode}`}
      className="pointer-events-none fixed z-[9998] rounded-frame border shadow-[inset_0_0_0_1px_rgb(255_255_255/0.08)]"
      style={{
        left: preview.box.x,
        top: preview.box.y,
        width: preview.box.width,
        height: preview.box.height,
      }}
    />
  );
}
